import * as React from 'react'
import { SVGProps } from 'react'

const SvgPlay = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 41.999 41.999" {...props}>
    <path d="m36.068 20.176-29-20A1 1 0 0 0 5.5.999v40a1 1 0 0 0 1.568.823l29-20a.999.999 0 0 0 0-1.646zM7.5 39.095V2.904L33.739 21 7.5 39.095z" />
  </svg>
)

export default SvgPlay
